import React from "react";
import why from "../../assets/images/why.jpg";
import { config } from "../config";
import { Link } from "react-router-dom";
import { useInView } from 'react-intersection-observer';

const FeatureSection = () => {
    const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref5, inView5] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref6, inView6] = useInView({ triggerOnce: true, threshold: 0.1 });
    return (
        <div>
            <div className="features-area pt-80 pb-80 bg-f7fafd">
                <div className="container">

                    <div className="row">
                        <div
                            className={`col-lg-6 col-md-6 aos-init aos-animate box-animate ${inView1 ? 'visible' : ''}`} ref={ref1}
                        >
                            <div className="about-info">
                                <h1>Why Choose Us</h1>
                                <p>
                                    Roliox Alloys is a dedicated aluminum recycling and manufacturing company focused on converting scrap into valuable raw material. Our facility processes a wide range of aluminum scrap such as UBC (Used Beverage Cans), aluminum foils, and radiator scrap.
                                </p>
                                <p>
                                    Our state-of-the-art facility is equipped with advanced furnace technology that ensures efficient melting, minimal waste, and optimal energy utilization. Every stage of our process is carefully monitored under strict quality control standards to guarantee consistency, purity, and superior mechanical strength in every product we deliver.
                                </p>
                                <p>
                                    We are committed to sustainability and environmental responsibility, reducing landfill waste while supporting a circular economy. By choosing us, you partner with a company that values precision, reliability, and long-term relationships.
                                </p>

                            </div>
                        </div>
                        <div
                            className={`col-lg-6 col-md-6 aos-init aos-animate box-animate ${inView2 ? 'visible' : ''}`} ref={ref2}
                        >
                            <div className="img-why">
                                <img src={why} width={"100%"} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureSection;
